import { william3_hash } from "bab_rs-wasm";
import { ByteString, FixedLengthByteString } from "./ByteString.js";
import { Willow25 } from "./Willow25.js";
export class PayloadDigest extends FixedLengthByteString(32) {
    static default() {
        return this.copy(Willow25.DEFAULT_PAYLOAD_DIGEST);
    }
    static async hash(payload) {
        const result = await william3_hash(payload);
        PayloadDigest.assertIs(result);
        return result;
    }
    static async verify(payloadDigest, payload) {
        const expectedHash = await PayloadDigest.hash(payload);
        return PayloadDigest.equals(payloadDigest, expectedHash);
    }
    length = PayloadDigest.LENGTH;
    byteLength = PayloadDigest.LENGTH;
}
//# sourceMappingURL=PayloadDigest.js.map